import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollTopWidget from './components/ScrollTopWidget';
import ScrollRestore from './components/ScrollRestore';
import { motion } from 'framer-motion';
import { posts } from './data/posts';
import Homepage from './pages/Homepage';
import Footer from './components/Footer';
import Projects from './pages/Projects';
import About from './pages/About';

export default function App() {
  return (
    <div className="min-h-screen w-full pt-36 gradient__bg">
    <ScrollTopWidget />
    <motion.div
      initial={{ opacity: 0}}
      animate={{ opacity: 1}}
      exit={{ opacity: 0}}
    >
    <Router>
      <ScrollRestore />
      <Navbar />
      <main>
        <Routes>
          <Route path="/me" element={<About posts={posts} />} />
          <Route path="/blog" element={<Homepage posts={posts} />} />
          <Route path="/projects" element={<Projects posts={posts} />} />
        </Routes>
      </main>
    </Router>
    </motion.div>
    <Footer />
    </div>
  )
}
